{
	"main": {
		"title": "Voli a Motore",
		"nazaj": "Indietro"
	},
	"nav": {
		"vnos": "Inserimento",
		"zapisi": "Registri"
	},
	"labelsM": {
		"datum": "Data:",
		"pilot": "Seleziona pilota:",
		"instruktor": "Seleziona istruttore:",
		"reg": "Seleziona matricola dell’aereo:",
		"namen": "Seleziona scopo:",
		"naloga": "Seleziona compito:",
		"vzlet": "Seleziona decollo:",
		"pristanek": "Seleziona atterraggio:",
		"nezakljucen": "Volo non completato?",
		"stPristankov": "Numero di atterraggi:",
		"opomba": "Nota",
		"niMozno": "Trattandosi di un volo a traino, è possibile modificare il registro solo per i voli a vela.",
		"opozorilo": "Gli orari riportati nelle liste di partenza vengono automaticamente registrati nel diario di bordo del pilota in formato UTC al momento del trasferimento.",
		"stanjeStevca": "Posizione del contatore",
		"v_zraku": "Durata del volo: ",
		"vnosTrajanja": "Inserimento tempo di volo?",
		"novIcao": "inserire il codice ICAO",
		"dodajLetalisce": "Aggiungi un aeroporto",
		"takeoff":  "Take off",
		"landing": "Landing"
	},
	"buttons": {
		"vnesiZapis": "Inserisci record",
		"brisiIzbiro": "Cancella selezione",
		"dodajLetalisce": "Aggiungi"
	},
	"obvestila": {
		"zapisPrihodnost": "Il record ha una data impostata nel futuro, CORREGGI la data selezionata!",
		"zapisCasPrihodnost": "Una o più voci contengono un orario impostato nel futuro, controlla gli orari!",
		"zapisCasNapaka": "Gli orari delle voci non sono corretti! Controlla di nuovo gli orari!",
		"napakaPristanka": "L'orario di atterraggio non può essere precedente all'orario di decollo!",
		"zapisPobrisan": "Record eliminato con successo",
		"zapisDodan": "Record aggiunto con successo.",
		"napakaPrazenPristanek": "Errore di inserimento, l'orario di atterraggio non può essere vuoto",
		"posodobitevUspesna": "Aggiornamento riuscito",
		"napakaPosodabljanja": "Errore durante l'aggiornamento dei dati.",
		"napakaBranja": "Errore durante la lettura dei dati.",
		"napakaIzbrisa": "Errore durante l'eliminazione dei dati.",
		"vprasanjeIzbris": "Sei sicuro di voler eliminare il record?",
		"napakaVnosa": "Errore di inserimento, controlla se tutti i campi obbligatori sono compilati!",
		"letZakljucen": "Volo completato con successo.",
		"letNiZakljucen": "Errore durante la conclusione del volo.",
		"napakaDodajanjaLetalisca": "Si è verificato un errore durante l'inserimento dell'aeroporto",
		"letalisceNiNajdeno": "Il codice ICAO dell'aeroporto non è presente nel database",
		"zapisFlightcasi": "Controlla gli orari di decollo e atterraggio!"
	}
}